import { useMutation, useQuery } from '@tanstack/react-query';

import { minutes } from '@utils/milliseconds';

import { getUploadedFileUrl, uploadFile } from './requests';

export const useUploadFile = (path: string, overwriteFile: boolean) => {
  return useMutation({
    mutationFn: (file: File) => uploadFile({ path, file, overwriteFile }),
  });
};

export const useUploadedFileUrlFromPath = (path: string) => {
  return useQuery({
    queryKey: ['uploaded-file-url', path],
    enabled: Boolean(path),
    staleTime: minutes(60),
    queryFn: () => getUploadedFileUrl(path),
  });
};
